export default {
  header: {
    lema: "...con identidad marista",
    recursos: "Recursos",
    contacto: "Contacto",
    buscar: "Buscar ilustraciones...",
    limpiar: "Limpiar búsqueda",
  },
  hamburguesa: {
    recursos: "Recursos",
    filtros: "Filtros",
    favoritos: "Favoritos",
    presentacion: "Presentación",
    contacto: "Contacto",
  },
  welcome: {
    title: "Recursos gráficos con identidad marista",
    p1: "Un repositorio abierto de ilustraciones y diseños para la pastoral, la educación y la comunidad.",
    p2: "Todo gratuito, descargable y libre de usar.",
  p3: "Esto es <strong>Marist-Art</strong>. Nada complicado (espero): un repositorio abierto de <strong>ilustraciones y diseños para la pastoral, la educación y la comunidad</strong>. Tienes filtros, búsqueda, y la opción de marcar favoritos.\n\nTodo gratuito, descargable y libre para uso no comercial. Además, algunos enlaces interesantes abajo.\n\nSi quieres comentar algo, o tienes sugerencias, no dudes en escribir. <strong>Bienvenidos</strong> todos.",
  button: "Ver recursos",
},
  filtros: {
    label: "Filtros",
    allFilters: "+ Todos los filtros",
    mobileFilters: "+ Filtros",
    results: "resultado",
    results_plural: "resultados",
    temas: "Temas",
    tags: "Tags",
    usos: "Usos",
    tintas: "Tintas",
    limpiar: "Limpiar",
    labels: {
    temas: {
  champagnat: "Champagnat",
  maria: "María",
  jesus: "Jesús",
  educacion: "educación",
  social: "social",
  deporte: "deporte",
  naturaleza: "naturaleza",
  tiempos_liturgicos: "tiempos litúrgicos",
  evangelio: "evangelio",
  paz: "paz",
  infantil: "infantil",
  violetas: "violetas",
  vocacional: "vocacional",
  hermitage: "Hermitage",
  gvx: "GVX",
  maristas: "maristas",
},
    tags: {
      firma: "firma",
      frase: "frase",
      logo: "logo",
      minimalista: "minimalista",
      sin_fondo: "sin fondo",
    },
    usos: {
      cartel: "cartel",
      colorear: "colorear",
      mural: "mural",
      postal: "postal",
      rrss: "rrss",
      sticker: "sticker",
      taza: "taza",
      textil: "textil",
    },
    tintas: {
      monocolor: "1 Tinta",
      bicolor: "2 Tintas",
      blanco_negro: "B/N",
      escala_grises: "Escala de grises",
      multicolor: "Multicolor",
    },
   },
  },
  favoritos: {
    confirmDelete: "¿Borrar todos los favoritos?",
    cancelar: "Cancelar",
    borrar: "Borrar",
  },
  lightbox: {
    descargar: "Descargar",
    original: "Original",
    adaptado: "Adaptado",
    de: "De:",
    cerrar: "Cerrar",
    anterior: "Anterior",
    siguiente: "Siguiente",
  },
  infopanels: {
    aboutTitle: "Presentación y Nota Legal",
    aboutText: `Me llamo Arturo Morales Pérez, soy laico marista de Champagnat, y formo parte de la Provincia Marista Mediterránea.

Además de mi tarea habitual (educador y catequista) a menudo suelo crear diseños e ilustraciones, o adaptarlos a formato digital, para lo propio de nuestras acciones pastorales, educativas, vocacionales, sociales y comunitarias.

Esta web/app tiene una finalidad sencilla: servir de repositorio de imágenes que he podido ir creando o vectorizando, relacionadas con esas finalidades. Se incluyen adaptaciones de dibujos o ilustraciones encontradas por la red o que han compartido conmigo. En esos casos, aparecerá "adaptada" en el título y, siempre que lo haya encontrado, citando el autor de la imagen o fragmento original. Una mención especial merece C_Towers, amigo y artista nato de brocha y ceras.

No es por tanto un estudio de diseño online ni una web de marketing, ni siquiera una página personal como artista. Todo el contenido se comparte bajo licencia Creative Commons BY-NC 4.0, y dispongo de los archivos originales. Consulta el aviso legal para más detalles.

Encantado de veros por aquí.`,
    contactTitle: "Consulta y Contacto",
    contactText: "Si tienes cualquier duda, consulta o aportación, puedes hacerlo desde aquí. Tus datos sólo se usarán para este fin.",
    emailPlaceholder: "Tu email",
    messagePlaceholder: "Mensaje",
    send: "Enviar",
    sending: "Enviando...",
    sent: "✔ Mensaje enviado correctamente",
    avisoLegal: "Aviso legal",
  },
  footer: {
    avisoLegal: "Aviso legal",
    cc: "CC BY-NC 4.0",
  },
  grid: {
    noResults: "Sin resultados. Prueba a modificar filtros o búsqueda.",
  },
};